import React from 'react';
import { AccentH5 } from 'scy/text';
import margin from 'scy/margin.mod.scss';
import { subsection } from 'components/checkoutPage/form/styles.mod.scss';

export default function Subsection({ heading, children }) {
  return (
    <div className={subsection}>
      <AccentH5
        uppercase
        tag="h1"
        marginClass={`${margin.top_0} ${margin.bottom_sm}`}
      >
        {heading}
      </AccentH5>
      {children}
    </div>
  );
}
